import { render, staticRenderFns } from "./FormLusazu.vue?vue&type=template&id=e706ce96&scoped=true"
import script from "./FormLusazu.vue?vue&type=script&lang=js"
export * from "./FormLusazu.vue?vue&type=script&lang=js"
import style0 from "./FormLusazu.vue?vue&type=style&index=0&id=e706ce96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e706ce96",
  null
  
)

export default component.exports